export default class Status {
	constructor({added_on, id, name, update_on}) {
		this.added_on = added_on || "";
		this.id = id || 0;
		this.name = name || "";
		this.update_on = update_on || "";
	}
}
